import { RootState } from 'store/store';
import { UserId } from 'features/users/types';

export const selectBreakoutOrUnassignedUser = (state: RootState, userId: UserId) =>
  state.breakoutRooms.users[userId] || state.breakoutRooms.unassignedUsers[userId];
